import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAyHruDHuaPMEuNAVbK_flZDL5-eMZVcs0",
  authDomain: "clone-f612b.firebaseapp.com",
  projectId: "clone-f612b",
  storageBucket: "clone-f612b.appspot.com",
  messagingSenderId: "705217740302",
  appId: "1:705217740302:web:3256fbc5c774bb8a7a865f",
};

const firebaseApp = initializeApp(firebaseConfig);

const db = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);

export { db, auth };
